"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamespacedFeatureValues = exports.NamespacedFeatureDefinitions = exports.FeatureDefinitions = exports.FeatureValues = exports.FeatureDefinition = exports.StringDefinition = exports.NumberDefinition = exports.BooleanDefinition = exports.DefinitionType = exports.FeatureValue = exports.BasicFeatureValue = exports.ComputedFeatureValue = exports.EntityChecker = exports.Entity = exports.EnvironmentChecker = exports.Environment = exports.OverrideType = void 0;
const z = __importStar(require("myzod"));
var OverrideType;
(function (OverrideType) {
    OverrideType["String"] = "string";
    OverrideType["Number"] = "number";
    OverrideType["Boolean"] = "boolean";
    OverrideType["Error"] = "error";
    OverrideType["PercentOf"] = "percentOf";
    OverrideType["BeforeDate"] = "beforeDate";
    OverrideType["AfterDate"] = "afterDate";
    OverrideType["Environmnent"] = "environment";
    OverrideType["Entry"] = "entry";
    OverrideType["Any"] = "any";
    OverrideType["All"] = "all";
    OverrideType["None"] = "none";
    OverrideType["Not"] = "not";
})(OverrideType = exports.OverrideType || (exports.OverrideType = {}));
var Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Integration"] = "integration";
    Environment["Production"] = "production";
    Environment["Test"] = "test";
})(Environment = exports.Environment || (exports.Environment = {}));
exports.EnvironmentChecker = z.enum(Environment);
var Entity;
(function (Entity) {
    Entity["Users"] = "users";
    Entity["Clients"] = "clients";
    Entity["Pages"] = "pages";
    Entity["Accounts"] = "accounts";
})(Entity = exports.Entity || (exports.Entity = {}));
exports.EntityChecker = z.enum(Entity);
const PercentOf = z.object({
    [Entity.Users]: z.number().optional(),
    [Entity.Clients]: z.number().optional(),
    [Entity.Pages]: z.number().optional(),
    [Entity.Accounts]: z.number().optional(),
});
const LazyFeatureValue = z.lazy(() => exports.FeatureValue);
exports.ComputedFeatureValue = z
    .object({ [OverrideType.PercentOf]: PercentOf })
    .or(z.object({ [OverrideType.BeforeDate]: z.string() }))
    .or(z.object({ [OverrideType.AfterDate]: z.string() }))
    .or(z.object({ [OverrideType.Environmnent]: z.enum(Environment) }))
    .or(z.object({ [OverrideType.Entry]: z.string() }))
    .or(z.object({ [OverrideType.Any]: z.array(LazyFeatureValue) }))
    .or(z.object({ [OverrideType.All]: z.array(LazyFeatureValue) }))
    .or(z.object({ [OverrideType.None]: z.array(LazyFeatureValue) }))
    .or(z.object({ [OverrideType.Not]: LazyFeatureValue }));
exports.BasicFeatureValue = z.string().or(z.number()).or(z.boolean());
exports.FeatureValue = exports.BasicFeatureValue.or(exports.ComputedFeatureValue);
var DefinitionType;
(function (DefinitionType) {
    DefinitionType["Boolean"] = "boolean";
    DefinitionType["Number"] = "number";
    DefinitionType["String"] = "string";
})(DefinitionType = exports.DefinitionType || (exports.DefinitionType = {}));
exports.BooleanDefinition = z.object({
    type: z.literal(DefinitionType.Boolean),
    errorFallback: z.boolean(),
    default: z.boolean().or(exports.ComputedFeatureValue),
    description: z.string(),
    intendedExpiry: z.string(),
});
exports.NumberDefinition = z.object({
    type: z.literal(DefinitionType.Number),
    errorFallback: z.number(),
    default: z.number(),
    description: z.string(),
    intendedExpiry: z.string(),
});
exports.StringDefinition = z.object({
    type: z.literal(DefinitionType.String),
    errorFallback: z.string(),
    default: z.string(),
    description: z.string(),
    intendedExpiry: z.string(),
});
exports.FeatureDefinition = exports.BooleanDefinition.or(exports.NumberDefinition).or(exports.StringDefinition);
// Work around myzod/typescript bug
exports.FeatureValues = z.object({ [z.keySignature]: exports.FeatureValue });
exports.FeatureDefinitions = z.object({ [z.keySignature]: exports.FeatureDefinition });
exports.NamespacedFeatureDefinitions = z.record(exports.FeatureDefinitions);
exports.NamespacedFeatureValues = z.record(exports.FeatureValues);
//# sourceMappingURL=types.js.map